import Header from "@/components/Header";
import About from "@/components/About";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="회사소개 - Central TG | JAX 모델 한국 대리점"
        description="Central TG는 미국 Jackson Laboratory의 한국 공식 파트너로서 고품질 transgenic 모델을 연구기관에 공급합니다. USDA 인증 및 AAALAC 기준 준수."
        keywords="Central TG 회사소개, JAX 파트너, Jackson Laboratory 한국, transgenic 모델 대리점, USDA 인증, AAALAC, 실험동물 전문업체"
        canonical="https://centraltg.co.kr/about"
      />
      <Header />
      <About />
      <Footer />
    </div>
  );
};

export default AboutPage;